import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { getLogoImage, RootState } from '../../store';
import { useEffect } from 'react';
import { GeneralAppSettingsType } from '../../store/actionTypes/settings/generalAppSettings';
import { sharedPaths } from '../../router/constants/route-paths';
import { UserRoles } from '../../utils';
import { UserDashboardTabNames } from '../thesisManagement/UserDashboard';

interface IProps {
    role: string;
}

export const Brand = (props: IProps) => {
    const getToPath = (userRole: string) => {
        if (userRole === UserRoles.user) {
            return `/${props.role.toLowerCase()}/${sharedPaths.dashboard}/${
                UserDashboardTabNames.yourProjects
            }`;
        }

        return `/${props.role.toLowerCase()}/${sharedPaths.dashboard}`;
    };

    const to = getToPath(props.role);

    const dispatch = useDispatch();

    const appSettings = useSelector(
        (state: RootState) => state.generalAppSettings
    );

    useEffect(() => {
        if (appSettings?.logoFilename) {
            dispatch(getLogoImage(appSettings.logoFilename));
        } else {
            dispatch({
                type: GeneralAppSettingsType.GET_LOGO_IMAGE_URL,
                payload: undefined,
            });
        }
    }, [appSettings.logoFilename, dispatch]);

    return (
        <Link className='navbar-brand' to={to}>
            <img
                src={appSettings.logoLink ?? ''}
                className='navbar-brand-img mx-auto'
                alt=''
            />
        </Link>
    );
};
